module.exports = __webpack_public_path__ + "static/media/banner-aug-23-mobile.4d698ae1.png";